var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _vm.data
        ? _c(
            "v-card-title",
            { staticClass: "pa-0" },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", disabled: _vm.page === 1 },
                  on: {
                    click: function ($event) {
                      _vm.page--
                    },
                  },
                },
                [_c("v-icon", [_vm._v("keyboard_arrow_left")])],
                1
              ),
              _c("v-spacer"),
              _c("span", [_vm._v(_vm._s(_vm.chartTitle))]),
              _c("v-spacer"),
              _vm.playable
                ? _c(
                    "span",
                    [
                      !_vm.update
                        ? _c(
                            "v-btn",
                            { attrs: { icon: "" }, on: { click: _vm.play } },
                            [_c("v-icon", [_vm._v("play_arrow")])],
                            1
                          )
                        : _c(
                            "v-btn",
                            { attrs: { icon: "" }, on: { click: _vm.pause } },
                            [_c("v-icon", [_vm._v("pause")])],
                            1
                          ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.allowDownloadData
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        loading: _vm.downloadPending,
                        disabled: _vm.disabledDownload,
                      },
                      on: { click: _vm.downloadData },
                    },
                    [_c("v-icon", [_vm._v("mdi-download")])],
                    1
                  )
                : _vm._e(),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", disabled: _vm.page === _vm.numPages },
                  on: {
                    click: function ($event) {
                      _vm.page++
                    },
                  },
                },
                [_c("v-icon", [_vm._v("keyboard_arrow_right")])],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-card-text",
        [
          _c(
            _vm.chartComponent,
            _vm._b(
              {
                tag: "component",
                attrs: {
                  type: _vm.type,
                  options: _vm.chartOptions,
                  data: _vm.chartData,
                },
              },
              "component",
              _vm.props,
              false
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }